import React from "react";

import { RankedTableDataProps } from "components/ranked-table/types";

import DesktopChart from "../../../ranked-table/desktop-chart";
import MobileChart from "../../../ranked-table/mobile-chart";
import { defaultCanvassingAppsList, defaultCanvassingFeatures } from "./features";

const chartTitle = "External Application";

type CanvassingAppsChartProps = RankedTableDataProps & {
  className?: string;
};
const CanvassingAppsChart = ({
  features: canvassingFeatures,
  integratorsList: canvassingApps,
  ...rest
}: CanvassingAppsChartProps) => {
  const loadedData = !!canvassingFeatures?.length && !!canvassingApps?.length;
  const chartProps = {
    features: loadedData ? canvassingFeatures : defaultCanvassingFeatures,
    integratorsList: loadedData ? canvassingApps : defaultCanvassingAppsList,
  };
  return (
    <>
      <DesktopChart title={chartTitle} {...chartProps} {...rest} />
      <MobileChart title={chartTitle} {...chartProps} {...rest} />
    </>
  );
};

export default CanvassingAppsChart;
